import { render, staticRenderFns } from "./_base_textarea.vue?vue&type=template&id=0e65f159&"
import script from "./_base_textarea.vue?vue&type=script&lang=js&"
export * from "./_base_textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports